<template>
  <div
      class="navbar-container d-flex content align-items-center"
  >
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
        >
          <feather-icon
              icon="MenuIcon"
              size="21"
          />
        </b-link>
      </li>
    </ul>

    <div class="navbar-left flex-grow-1">
      <div
          class="bg-logo d-none d-lg-block"
      />
    </div>

    <b-navbar-nav
        class="nav align-items-center ml-auto"
    >
      <dark-toggler
          class="d-none d-lg-block"
      />

      <notification-dropdown />

      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
} from 'bootstrap-vue'

import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

import {
  startNotificationHub,
  stopNotificationHub,
} from '@/libs/vue-signalR'

export default {
  name: 'AppNavbarVerticalLayout',

  components: {
    BLink,
    BNavbarNav,
    DarkToggler,
    NotificationDropdown,
    UserDropdown,
  },

  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  async mounted() {
    /*
     * کامپوننت فرزند قبل از mounted والد،
     * listenerهای subscriberBus را ثبت کرده است.
     */
    const hub =
        await startNotificationHub()

    console.log(
        '[Navbar] NotifyHub state:',
        hub ? hub.state : 'Disconnected',
    )
  },

  beforeDestroy() {
    stopNotificationHub()
  },
}
</script>

<style scoped>
.navbar-container {
  width: 100%;
}

.navbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.bg-logo {
  width: 5rem;
  height: 5rem;
  background-image:
      url("../../../../../src/assets/images/logo/logo.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>